import { z } from 'zod';
import { objectiveHealthStatusSchema } from '../notification-dto';
import { baseEmailDTOSchema } from './base-email-dto';

export const planningEmailSchemas = [
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('demand_framework_changed_notification'),
    data: z.object({
      name: z.string().min(1),
      previousFrameworkName: z.string().min(1),
      newFrameworkName: z.string().min(1),
      locale: z.string().optional(),
      actionUrl: z.string().url(),
      notificationSettingsUrl: z.string().url().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('plan_published_notification'),
    data: z.object({
      name: z.string().min(1),
      publisherName: z.string().nullish(),
      portfolioName: z.string().min(1),
      locale: z.string().optional(),
      actionUrl: z.string().url(),
      notificationSettingsUrl: z.string().url().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('objective_drift_detected_notification'),
    data: z.object({
      name: z.string().min(1),
      objectiveName: z.string(),
      previousStatus: objectiveHealthStatusSchema,
      newStatus: objectiveHealthStatusSchema,
      portfolioName: z.string().nullish(),
      actionUrl: z.string().url(),
      notificationSettingsUrl: z.string().url().optional(),
      locale: z.string().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('new_critical_insight_notification'),
    data: z.object({
      name: z.string().min(1),
      insightTitle: z.string(),
      portfolioName: z.string().nullish(),
      actionUrl: z.string().url(),
      notificationSettingsUrl: z.string().url().optional(),
      locale: z.string().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('new_high_insight_notification'),
    data: z.object({
      name: z.string().min(1),
      insightTitle: z.string(),
      portfolioName: z.string().nullish(),
      actionUrl: z.string().url(),
      notificationSettingsUrl: z.string().url().optional(),
      locale: z.string().optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('credit_pool_low_notification'),
    data: z.object({
      name: z.string().min(1),
      organizationDisplayName: z.string(),
      actionUrl: z.string().url(),
      notificationSettingsUrl: z.string().url().optional(),
      locale: z.string().optional(),
    }),
  }),
] as const;
